import { DELETE, POST_MULTIPART } from "@/services/api";
import { API_ROUTES } from "@/services/environment";
import axios, { AxiosResponse } from "axios";

const { bsnsUploadImg, uploadFileApi, deleteFileApi } = API_ROUTES;

// Reusable file upload function
export const s3UploadFile = async (
  file: any,
  refreshToken: string
): Promise<AxiosResponse<any>> => {
  try {
    const res = await POST_MULTIPART(uploadFileApi, { file }, refreshToken);
    return res;
  } catch (error) {
    console.error("File upload failed:", error);
    throw error; // Rethrow the error to handle it outside the function
  }
};

export const s3DeleteFile = async (
  url: any,
  refreshToken: string,
  data?: { businessId: string; imageType: 'logo'|'videos'|'primary'|'portfolio'; remainingUrls: string[]|null }|null
): Promise<AxiosResponse<any>> => {
  try {
    const res = await DELETE(deleteFileApi, refreshToken, { url, data });

    return res;
  } catch (error) {
    console.error("File upload failed:", error);
    throw error; // Rethrow the error to handle it outside the function
  }
};
